import React from "react";
import { FaComments } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import jessProfileIcon from "../../../assets/navbar/iconperfiljesss.svg";
import jessProfileIconOff from "../../../assets/navbar/iconperfiljesssOff.svg";
import jessNameLogo from "../../../assets/navbar/nomejesss.svg";
import {
  Box,
  Card,
  CardContent,
  Container,
  Typography,
  Button,
  Grid,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Typewriter } from "react-simple-typewriter";
import { STATUS } from "../../../constants";
import { useDashboardTheme } from "../context/DashboardThemeContext";
interface StatusPageProps {
  jessPhoneNumber: string;
  statusJess: STATUS;
}
const JessPage: React.FC<StatusPageProps> = ({
  jessPhoneNumber,
  statusJess,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isDark = useDashboardTheme();
  const formatPhoneNumber = (phoneNumber: string): string => {
    const countryCode = "55";
    const numberWithoutCountryCode = phoneNumber.slice(2);
    const areaCode = numberWithoutCountryCode.slice(0, 2);
    const mainNumber = numberWithoutCountryCode.slice(2);
    const formattedNumber =
      mainNumber.length === 8
        ? `${mainNumber.slice(0, 4)}-${mainNumber.slice(4)}`
        : `${mainNumber.slice(0, 5)}-${mainNumber.slice(5)}`;
    return `+${countryCode} ${areaCode} ${formattedNumber}`;
  };
  return (
    <Container maxWidth="xl">
      <Grid container justifyContent="center">
        <Grid size={{ xs: 12 }}>
          {/* Header como card sem borda, agora com Divider */}
          <Card
            sx={{
              width: "100%",
              maxWidth: { xs: "100%", md: "40.13rem" },
              mx: "auto",
              boxShadow: 3,
              borderRadius: "16px",
              backgroundColor: isDark ? "rgba(30, 30, 30, 0.95)" : "#fff",
              border: isDark ? "1px solid rgba(255,255,255,0.08)" : undefined,
              mb: 1,
              p: 0,
            }}
          >
            <CardContent
              sx={{
                p: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: { xs: "column", md: "row" },
                gap: 2,
              }}
            >
              {/* Profile picture */}
              <Box
                sx={{
                  width: { xs: 100, md: 90 },
                  height: { xs: 100, md: 90 },
                  flexShrink: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={
                    statusJess === STATUS.Online
                      ? jessProfileIcon
                      : jessProfileIconOff
                  }
                  alt="Jess"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                />
              </Box>
              {/* Text information */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  textAlign: { xs: "center", md: "start" },
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "center", md: "flex-start" },
                    mb: 0.5,
                  }}
                >
                  <img
                    src={jessNameLogo}
                    alt="Jesss"
                    style={{
                      height: "32px",
                      objectFit: "contain",
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: 13,
                    color: isDark ? "#a0a0a0" : "#414042",
                    mb: 0.5,
                  }}
                >
                  {statusJess === STATUS.Online && (
                    <span style={{ color: "#06D6A0", fontWeight: 600 }}>
                      Online
                    </span>
                  )}
                  {statusJess === STATUS.Offline && (
                    <span style={{ color: "#DC3545", fontWeight: 600 }}>
                      Offline
                    </span>
                  )}
                  {statusJess === STATUS.ConectWhatsapp && (
                    <span style={{ color: "#E60000", fontWeight: 600 }}>
                      {t("connect_whatsapp")}
                    </span>
                  )}
                  {statusJess === STATUS.OpenAgent && (
                    <span style={{ color: "#E76F51", fontWeight: 600 }}>
                      {t("open_agent")}
                    </span>
                  )}
                </Typography>
                {jessPhoneNumber ? (
                  <Typography
                    component="a"
                    href={`https://wa.me/${jessPhoneNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      fontSize: { xs: 14, md: 16 },
                      color: isDark ? "#e0e0e0" : "#414042",
                      textDecoration: "none",
                      m: 0,
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      "&:hover": {
                        color: "#25D366",
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {formatPhoneNumber(jessPhoneNumber)}
                  </Typography>
                ) : (
                  <Typography
                    sx={{ fontSize: 14, color: isDark ? "#707070" : "#6C757D" }}
                  >
                    {t("message_phone_unavailable")}
                  </Typography>
                )}
              </Box>
              {/* Typing animation + action button */}
              {statusJess === STATUS.Online && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flexShrink: 0,
                    minWidth: { md: "280px", lg: "320px" },
                    maxWidth: { md: "280px", lg: "320px" },
                  }}
                >
                  <Box
                    sx={{
                      p: "12px 16px",
                      textAlign: "center",
                      width: "100%",
                      minHeight: "80px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: 13, md: 14 },
                        color: isDark ? "#c0c0c0" : "#414042",
                        lineHeight: 1.5,
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                      }}
                    >
                      <Typewriter
                        words={[
                          t("how_can_i_help_you"),
                          t("customize_communication"),
                          t("tone_of_voice"),
                          t("language_style"),
                          t("essential_information"),
                          t("information_to_avoid"),
                          t("customized_communication_guide"),
                        ]}
                        loop
                        cursor
                        cursorStyle="_"
                        typeSpeed={70}
                        deleteSpeed={10}
                        delaySpeed={3000}
                      />
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate("/chat-jess")}
                    sx={{
                      background: "#4E36A0",
                      fontSize: { xs: 13, md: 14 },
                      py: 1,
                      px: 2.5,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {t("give_instructions_to_jess")}
                    <FaComments
                      style={{ marginLeft: "8px", fontSize: "14px" }}
                    />
                  </Button>
                </Box>
              )}
            </CardContent>
            {/* Linha de separação padrão do MUI */}
            <Divider sx={{ mx: 3 }} />
          </Card>
        </Grid>
      </Grid>
      {/* Trechos comentados mantidos para possíveis estados vazios */}
      {/*
      <Box sx={{ textAlign: "center", my: 5 }}>
        <img
          src={emptyStateImage}
          alt={t("No sessions yet")}
          style={{ width: "150px", marginBottom: "20px" }}
        />
        <Typography variant="h5" className="subtitle">
          {t("No sessions yet")}
        </Typography>
      </Box>
      */}
    </Container>
  );
};
export default JessPage;
